import { Observable } from "../observable";
import "./pagination.css";

class PaginationElement extends HTMLElement {
    static observedAttributes = [
        "count",
        "limit",
        "offset",
        "limitkey",
        "offsetkey",
        "page-num-class",
        "page-prev-class",
        "page-next-class",
    ];

    #unsubs: Function[] = [];

    $attributes = new Observable<{
        count: number;
        limit: number;
        offset: number;
        limitKey: string;
        offsetKey: string;
        pageNumClass: string;
        pagePrevClass: string;
        pageNextClass: string;
    }>({
        count: 0,
        limit: 0,
        offset: 0,
        limitKey: "limit",
        offsetKey: "offset",
        pageNumClass: "",
        pagePrevClass: "",
        pageNextClass: "",
    });

    constructor() {
        super();
    }

    attributeChangedCallback(name: string, oldValue: string, newValue: string) {
        if (oldValue !== newValue) {
            switch (name) {
                case "count":
                    this.$attributes.broadcast((prev) => ({
                        ...prev,
                        count: parseInt(newValue),
                    }));
                    break;
                case "limit":
                    this.$attributes.broadcast((prev) => ({
                        ...prev,
                        limit: parseInt(newValue),
                    }));
                    break;
                case "offset":
                    this.$attributes.broadcast((prev) => ({
                        ...prev,
                        offset: parseInt(newValue),
                    }));
                    break;
                case "limitkey":
                    this.$attributes.broadcast((prev) => ({
                        ...prev,
                        limitKey: newValue,
                    }));
                    break;
                case "offsetkey":
                    this.$attributes.broadcast((prev) => ({
                        ...prev,
                        offsetKey: newValue,
                    }));
                    break;
                case "page-num-class":
                    this.$attributes.broadcast((prev) => ({
                        ...prev,
                        pageNumClass: newValue,
                    }));
                    break;
                case "page-prev-class":
                    this.$attributes.broadcast((prev) => ({
                        ...prev,
                        pagePrevClass: newValue,
                    }));
                    break;
                case "page-next-class":
                    this.$attributes.broadcast((prev) => ({
                        ...prev,
                        pageNextClass: newValue,
                    }));
                    break;
            }
        }
    }

    connectedCallback() {
        this.innerHTML = "";

        const prevButton = document.createElement("a");
        prevButton.className = "bd-button bd-button-icon bd-surface-20";
        prevButton.innerHTML = `<bd-icon value="nav-arrow-left"></bd-icon>`;

        const nextButton = document.createElement("a");
        nextButton.className = "bd-button bd-button-icon bd-surface-20";
        nextButton.innerHTML = `<bd-icon value="nav-arrow-right"></bd-icon>`;

        const pageButtonsContainer = document.createElement("span");
        pageButtonsContainer.style.display = "contents";

        this.appendChild(prevButton);
        this.appendChild(pageButtonsContainer);
        this.appendChild(nextButton);

        this.#unsubs.push(
            this.$attributes.subscribe(
                ({
                    limit,
                    offset,
                    count,
                    limitKey,
                    offsetKey,
                    pageNumClass,
                    pageNextClass,
                    pagePrevClass,
                }) => {
                    if (pageNextClass) {
                        nextButton.className = pageNextClass;
                    }
                    if (pagePrevClass) {
                        prevButton.className = pagePrevClass;
                    }

                    const pages =
                        limit > 0 ? Math.max(Math.ceil(count / limit), 1) : 1;
                    const currentPage =
                        limit > 0 ? Math.floor(offset / limit) + 1 : 1;

                    if (currentPage === 1) {
                        prevButton.classList.add("disabled");
                        prevButton.removeAttribute("href");
                    } else {
                        prevButton.classList.remove("disabled");
                        const url = new URL(window.location.href);
                        url.searchParams.set(limitKey, String(limit));
                        url.searchParams.set(
                            offsetKey,
                            String((currentPage - 2) * limit),
                        );
                        prevButton.href = url.search;
                        prevButton.setAttribute("bd-boost", "page");
                    }

                    if (currentPage === pages) {
                        nextButton.classList.add("disabled");
                        nextButton.removeAttribute("href");
                    } else {
                        nextButton.classList.remove("disabled");
                        const url = new URL(window.location.href);
                        url.searchParams.set(limitKey, String(limit));
                        url.searchParams.set(
                            offsetKey,
                            String(currentPage * limit),
                        );
                        nextButton.href = url.search;
                        nextButton.setAttribute("bd-boost", "page");
                    }

                    let pLinks = "";
                    for (let pi = 1; pi <= pages; pi++) {
                        const url = new URL(window.location.href);
                        url.searchParams.set(limitKey, String(limit));
                        url.searchParams.set(
                            offsetKey,
                            String((pi - 1) * limit),
                        );
                        let buttonClass = "";
                        if (pageNumClass) {
                            buttonClass = pageNumClass;
                            if (currentPage === pi) {
                                buttonClass += " active";
                            }
                        } else {
                            buttonClass = "bd-button bd-button-icon";
                            if (currentPage === pi) {
                                buttonClass += " bd-primary-10";
                            } else {
                                buttonClass += " bd-surface-20";
                            }
                        }

                        pLinks += `<a class="${buttonClass}" href="${url.search}" bd-boost="page">${pi}</a>`;
                    }

                    pageButtonsContainer.innerHTML = pLinks;
                },
                true,
            ),
        );
    }

    disconnectedCallback() {
        this.#unsubs.forEach((unsub) => {
            unsub();
        });
        this.#unsubs = [];
    }
}

customElements.define("bd-pagination", PaginationElement);
